<div aria-labelledby="categorical-traits-tab" class="tab-pane active container-fluid" role="tabpanel">
	<div class="row">
		<div class="col-12">
			<div class="d-flex justify-content-between align-items-start">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.description"></span>
			</div>
		</div>
	</div>
	<div class="table-responsive">
		<table class="table table-striped table-bordered table-curved">
			<thead>
            <tr>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.trait"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.number.of.locations"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.number.of.lines"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.number.of.observations"></span>
			</th>

			<ng-container *ngIf="headerValues.length > 0">
				<th *ngFor="let cValue of headerValues">
					<span>{{ showCategoricalHead(cValue) }}</span>
				</th>
			</ng-container>

			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.condition"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.limits"></span>
			</th>
			<th [ngStyle]="{ 'min-width': '120px' }">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.weight"></span>
			</th>
            </tr>
			<tbody *ngIf="traitFilterContext.hasCategoricalTraits() else nodata">
			<tr *ngFor="let categoricalTrait of traitFilterContext.categoricalTraits">
				<td>
					<a (click)="$event.stopPropagation()" [queryParams]="{ name: categoricalTrait.name, type: 'categorical' }" [routerLink]="['/', { outlets: { popup: 'trait-observation-dialog/' + categoricalTrait.id } }]" queryParamsHandling="merge">
						<truncate-span [textInput]="categoricalTrait.name">
						</truncate-span>
					</a>
				</td>
				<td>{{ categoricalTrait.locationCount }}</td>
				<td>{{ categoricalTrait.germplasmCount }}</td>
				<td>{{ categoricalTrait.observationCount }}</td>
				<td *ngFor="let value of headerValues "> {{ showCategoricalValue(value, categoricalTrait.values) }}</td>
				<td [ngStyle]="{ 'min-width': '120px' }">
					<select (ngModelChange)="selectedCondition(categoricalTrait)" [(ngModel)]="categoricalTrait.condition" class="form-select">
						<ng-container>
							<option *ngFor="let opt of conditionOptions" [value]="opt.value">
								{{ opt.label | translate }}
							</option>
						</ng-container>
					</select>
				</td>
				<td>
					<input [(ngModel)]="categoricalTrait.limits"
						   [class.is-invalid]="!traitFilterContext.isCategoricalLimitValid(categoricalTrait)"
						   [disabled]="isLimitsDisabled(categoricalTrait)"
						   class="form-control"
						   type="text"/>
					<div *ngIf="!traitFilterContext.isCategoricalLimitValid(categoricalTrait)" class="invalid-feedback d-block">
						{{ showMessageError(categoricalTrait) }}
					</div>
				</td>
				<td [ngStyle]="{ 'min-width': '120px' }">
					<select [(ngModel)]="categoricalTrait.priority"
							[disabled]="categoricalTrait.condition === TraitCondition.DROP_TRAIT" class="form-select">
						<ng-container>
							<option *ngFor="let opt of traitWeightOptions" [value]="opt.value">
								{{ opt.label | translate }}
							</option>
						</ng-container>
					</select>
				</td>
			</tbody>
		</table>
		<ng-template #nodata>
			<tbody>
			<tr>
				<td class="no-records" colspan="7" jhiTranslate="no.data"></td>
			</tr>
			</tbody>
		</ng-template>
	</div>
</div>
